;(function () {
  'use strict'

  angular.module('contrast.highcharts').constant('HIGHCHARTS_COLORS', {
    PLOT_LINE: '#bfbfbf',
    PLOT_LINE_TOOLTIP: '#808080',
    WHITE: '#ffffff',
    DISABLED_SERIES: '#bfbfbf',
    TRANSPARENT: 'transparent',
    DRILLDOWN_TOOLTIP_BACKGROUND: '#3a3a3a',
    PROTECT_USAGE_TOOLTIP_BACKGROUND: '#3a3a3a',
    Y_AXIS_SCALE: '#cccccc',
    HIGHEST_Y_VALUE: '#A7CD55'
  })
})()
